

































































































































































































































































/* tslint:disable:no-console */
import DateField from '@/components/DateField.vue';
import CustomDateField from '@/components/CustomDateField.vue';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { api } from '@/api';
import { Validator } from 'vee-validate';
import formatting from '@/formatting';
import { ChoiceOption, ChoiceOptionList } from '@/interfaces';
import { Getter, Mutation } from 'vuex-class';

@Component({
  components: { DateField, CustomDateField },
  directives: {
    disabledIconFocus: {
      bind(el) {
        el.querySelectorAll('.v-input__icon button').forEach((x) =>
          x.setAttribute('tabindex', '-1')
        );
      }
    }
  }
})
export default class DetailField extends Vue {
  // Props
  @Prop(String) public readonly label!: string;
  @Prop({ type: String, default: '' }) public readonly info!: string;
  @Prop(String) public readonly field!: string;
  @Prop(String) public readonly apiDownloadUrl!: string;
  @Prop({ type: String, default: '' }) public readonly field2!: string;
  @Prop({ type: Boolean, default: false }) public readonly required!: boolean;
  @Prop({ type: Boolean, default: false }) public readonly isReadOnly!: boolean;
  @Prop({ type: Boolean, default: true }) public readonly clearable!: boolean;
  @Prop({ type: String, default: 'text' }) public readonly dataType!: string;
  @Prop(Array) public readonly rules;
  @Prop(Object) public readonly validator!: object;
  @Prop({ type: Array, default: null }) public readonly optionList!:
    | ChoiceOption[]
    | null;
  @Prop({ type: String, default: null }) public readonly optionListName!:
    | string
    | null;
  @Prop({ type: Object, default: null }) public readonly optionListParams!:
    | object
    | null;
  @Prop(Object) public readonly rec!: object;

  public finalOptionList: ChoiceOption[] = [];

  // Getters & setters
  public get allRules() {
    let rules = this.rules;
    if (this.required) {
      const requiredRule = [(v) => !!v || 'Dit veld is verplicht'];
      rules = rules ? requiredRule.concat(rules) : requiredRule;
    }
    return rules;
  }

  @Getter('getCachedChoice')
  public getCachedChoice!: (name: string) => ChoiceOptionList;

  @Mutation('setCachedChoice')
  public setCachedChoice;

  // Functions
  public formatTimeStamp(timestamp) {
    return formatting.formatTimeStamp(timestamp);
  }

  public onInput(value, isEnterEvent) {
    this.$emit('input', value);
    if (isEnterEvent) {
      this.$emit('enter', value);
    }
  }

  // Custom filter autocomplete to ignore spaces (trim)
  public customFilter(item, queryText, itemText) {
    return (
      itemText
        .toLocaleLowerCase()
        .indexOf(queryText.trim().toLocaleLowerCase()) > -1
    );
  }

  public setOptions() {
    if (this.optionList) {
      // Static option list
      this.finalOptionList = this.optionList;
    } else if (this.optionListName) {
      // Dynamic option list
      if (this.optionListParams) {
        // Don't cache
        this.getOptionList(this.optionListName, this.optionListParams);
      } else {
        this.getCachedOptionList(this.optionListName);
      }
    }
  }

  // Get option list from API
  public async getOptionList(optionListName, optionListParams) {
    const response = await api.getChoices(
      this.$store,
      '/' + this.optionListName + '/choice/',
      optionListParams
    );
    if (response) {
      this.finalOptionList = response.data.records;
    }
  }

  // Get option list from cache
  public async getCachedOptionList(optionListName) {
    const cachedList: ChoiceOptionList = this.getCachedChoice(optionListName);
    let checksum = '';
    if (cachedList) {
      checksum = cachedList.checksum;
    }
    const response = await api.getChoices(
      this.$store,
      '/' + this.optionListName + '/choice/',
      { checksum }
    );
    if (response) {
      if (response.data.records.length > 0) {
        // Update cache
        this.setCachedChoice({
          name: this.optionListName,
          value: response.data
        });
        this.finalOptionList = response.data.records;
      } else {
        // Cache up-to-date
        if (cachedList) {
          this.finalOptionList = cachedList.records;
        } else {
          // Empty list
          this.finalOptionList = [];
        }
      }
    }
  }

  public downloadItem() {
    api.downloadFile(this.$store, this.apiDownloadUrl + '/url');
  }

  public async deleteItem() {
    await api.deleteRecord(this.$store, this.apiDownloadUrl);
    this.$emit('reload');
  }

  public isEmpty(obj) {
    if (obj) {
      return Object.keys(obj).length === 0;
    } else {
      return true;
    }
  }

  public openGoogleMaps(value) {
    const coords: any = formatting.formatCoordinates(value);
    if (coords) {
      let link = 'https://www.google.com/maps/search/?api=1';
      link += '&query=' + coords.lat + ',' + coords.lon;
      window.open(link, '_blank');
    }
  }

  @Watch('optionListParams') public changed(oldValue, newValue) {
    if (!this.isEmpty(oldValue) || !this.isEmpty(newValue)) {
      // Reset values and selected value when parameters changed
      if (JSON.stringify(oldValue) !== JSON.stringify(newValue)) {
        this.setOptions();
        this.$emit('clear');
      }
    }
  }

  // Lifecycle Functions
  public created() {
    this.setOptions();
  }
}
